var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDistracted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4762 30.1781V26.6L40 32.3L30.4762 38V34.028C24.6141 33.1926 19.5263 29.371 17.1484 23.8361L17.1429 23.8233L17.1373 23.8361C14.4361 30.1234 8.23825 34.2 1.38063 34.2H0V30.4H1.38063C6.71434 30.4 11.5348 27.2293 13.6359 22.3391L15.0705 19L13.6359 15.6609C11.5348 10.7707 6.71434 7.6 1.38063 7.6H0V3.8H1.38063C8.23825 3.8 14.4361 7.87658 17.1373 14.164L17.1429 14.1767L17.1484 14.164C19.5263 8.62904 24.6141 4.80742 30.4762 3.97197V0L40 5.7L30.4762 11.4V7.822C26.1459 8.6215 22.4261 11.5267 20.6499 15.6609L19.2152 19L20.6499 22.3391C22.4261 26.4733 26.1459 29.3786 30.4762 30.1781Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistracted);
export default __webpack_public_path__ + "static/media/Distracted.e9afa32932d90ff4d4584db87b956d9a.svg";
export { ForwardRef as ReactComponent };